import type { AnyRouter, MakeRouteMatchUnion } from '@tanstack/react-router';
import type { Permission } from './permision';

declare module '@tanstack/react-router' {
  interface StaticDataRouteOption {
    permissions?: readonly Permission[];
  }
}

export function canAccessRouteMatches(
  matches: MakeRouteMatchUnion[],
  userPermissions: ReadonlySet<string>,
): boolean {
  return matches.every(({ staticData }) => {
    const requiredPermissions = staticData.permissions;

    return (
      !requiredPermissions?.length ||
      requiredPermissions.some((permission) => userPermissions.has(permission))
    );
  });
}

export function canAccessRoutePath(
  router: AnyRouter,
  path: string,
  userPermissions: ReadonlySet<string>,
) {
  const foundRoute = router.routesByPath[path];

  if (!foundRoute) {
    return false;
  }

  const matches = router.matchRoutes(path);

  return matches.length > 0 && canAccessRouteMatches(matches, userPermissions);
}
